import { render, staticRenderFns } from "./personIn.vue?vue&type=template&id=6447f825&scoped=true&"
import script from "./personIn.vue?vue&type=script&lang=js&"
export * from "./personIn.vue?vue&type=script&lang=js&"
import style0 from "./personIn.vue?vue&type=style&index=0&id=6447f825&lang=less&scoped=true&"
import style1 from "./personIn.vue?vue&type=style&index=1&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6447f825",
  null
  
)

export default component.exports